import { useLocation } from 'react-router-dom';

const useQueryParams = () => {
  const { search } = useLocation();
  const queries = new URLSearchParams(search);
  const createSearchParams = (obj) => new URLSearchParams(obj).toString();
  const getParam = (paramName) => queries.get(paramName) || null;
  const getArrParam = (paramName) => queries.getAll(paramName) || null;

  return {
    queries,
    getParam,
    getArrParam,
    createSearchParams,
  };
};

export default useQueryParams;
